import { component, getter, action } from '../../decorators';

import { OPENER_MIXIN } from '../../mixins/opener.mixin';
import { LOGOUT } from '../../store/actions';

import LanguageRepository from '../../repositories/languages-repository';


const repository = new LanguageRepository();

@component({
   mixins: [ OPENER_MIXIN ]
})
export default class ProfileMenuItem {

   @getter() getCurrentUser;
   @getter() language;
   @getter('currentLanguageLabel') languageLabel;
   @action(LOGOUT) logout

   get username() {
      const u = this.getCurrentUser;
      return `${u.firstName} ${u.lastName}`;
   }

   get languages() {
      return this.$store.state.auth.languages;
   }

   gotoOrders() {
      //
   }

   async changeLanguage(language) {
      await repository.change(language.code);
      window.location.reload();
   }
}
